<template>
	<div class="product-detail-container">
		<button class="back-button" @click="goBack">← {{ $t('返回') }}</button>

		<div class="product-image">
			<img :src="fullImageUrl" :alt="product.name" />
		</div>

		<div class="product-info">
			<h1 class="product-name">{{ product.name }}</h1>
			<p class="product-subtitle">{{ product.subtitle }}</p>
			<p class="product-price">{{ product.price | currency(product.is_overseas) }}</p>

			<div class="product-features">
				<span v-for="(feature, index) in featureList" :key="index" class="feature-tag">
					{{ feature }}
				</span>
			</div>
		</div>

		<div class="product-details">
			<div class="product-details" v-html="formattedDetails"></div>
		</div>

		<div v-if="product.datasheet_url && product.datasheet_url.length > 0" class="datasheet-section">
			<div class="datasheet-gallery">
				<img 
					v-for="(datasheet, index) in product.datasheet_url" 
					:key="index"
					:src="getFullDatasheetUrl(datasheet)" 
					:alt="'产品数据图' + (index + 1)" 
					class="datasheet-image" 
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { productApi, baseImgUrl } from '../netTool/api';

export default {
	name: 'ProductDetail',
	data() {
		return {
			product: {
				id: 0,
				name: '',
				image_url: '',
				features: '',
				details: '',
				datasheet_url: [], // 改为数组
				price: '0.00',
				subtitle: '',
				is_overseas: 0
			},
			baseImgUrl: baseImgUrl
		};
	},
	computed: {
		formattedDetails() {
			if (!this.product.details) return '';
			let formatted = this.product.details.replace(/\n\n/g, '</p><p>');
			formatted = formatted
				.replace(/【(.*?)】/g, '<h3>$1</h3>') 
				.replace(/\[(.*?)\]/g, '<h3>$1</h3>');
			return formatted;
		},
		featureList() {
			return this.product.features ? this.product.features.split('，') : [];
		},
		fullImageUrl() {
			return this.product.image_url ? `${this.baseImgUrl}${this.product.image_url}` : '';
		}
	},
	filters: {
		currency(value, isOverseas) {
		    const currencySymbol = (isOverseas === 1 || isOverseas === '1') ? '$' : '¥';
		    if (!value) return currencySymbol + '0.00';
		    const num = parseFloat(value);
		    if (isNaN(num)) return currencySymbol + '0.00';
		    return currencySymbol + num.toFixed(2);
		}
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		getFullDatasheetUrl(datasheet) {
			return datasheet ? `${this.baseImgUrl}${datasheet}` : '';
		},
		async getData() {
			try {
				const response = await productApi.getProductById(this.$route.params.id);

				if (response.success && response.product) {
					this.product = {
						...response.product,
						// 确保datasheet_url是数组，如果是字符串就转为数组
						datasheet_url: response.product.datasheet_url 
							? Array.isArray(response.product.datasheet_url) 
								? response.product.datasheet_url 
								: [response.product.datasheet_url]
							: []
					};
				}
			} catch (error) {
				console.error('获取产品详情失败:', error);
			}
		}
	},
	created() {
		this.getData();
	}
};
</script>

<style scoped>
.product-detail-container {
	max-width: 1200px;
	margin: 0 auto;
	padding: 20px;
	font-family: 'Arial', sans-serif;
}

.back-button {
	background: none;
	border: none;
	font-size: 16px;
	cursor: pointer;
	margin-bottom: 20px;
	padding: 8px 16px;
	border-radius: 4px;
	transition: background-color 0.3s;
}

.back-button:hover {
	background-color: #f0f0f0;
}

.product-image img {
	width: 100%;
	max-height: 500px;
	object-fit: contain;
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.product-info {
	margin: 30px 0;
}

.product-name {
	font-size: 28px;
	color: #333;
	margin-bottom: 8px;
}

.product-subtitle {
	font-size: 18px;
	color: #666;
	margin-bottom: 16px;
}

.product-price {
	font-size: 20px;
	color: #e63946;
	margin-bottom: 20px;
}

.product-features {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.feature-tag {
	background-color: #f8f9fa;
	border: 1px solid #dee2e6;
	border-radius: 20px;
	padding: 6px 14px;
	font-size: 14px;
	color: #495057;
}

.product-details {
	margin: 40px 0;
	line-height: 1.6;
	color: #444;
}

.product-details h2,
.datasheet-section h2 {
	font-size: 24px;
	margin-bottom: 16px;
	padding-bottom: 8px;
	border-bottom: 1px solid #eee;
}

.datasheet-section {
	margin: 40px 0;
}

.datasheet-gallery {
	display: grid;
	/* grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); */
	/* gap: 20px; */
	/* margin-top: 20px; */
}

.datasheet-image {
	width: 100%;
	object-fit: contain;
	border: 1px solid #eee;
	border-radius: 4px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s;
}

.datasheet-image:hover {
	/* transform: scale(1.02); */
}
</style>